import type { SchemaBuilderFieldActionsProps } from "./schema-builder-field-actions.type";

import {
  CopyOutlined,
  DeleteOutlined,
  EditOutlined,
  ReadOutlined,
} from "@ant-design/icons";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

import { isSchemaFieldEditable } from "../schema-builder-field-editor";

export const SchemaBuilderFieldActions = ({
  schema,
  onPreviewClick,
  onEditClick,
  onCopyClick,
  onDeleteClick,
}: SchemaBuilderFieldActionsProps) => {
  const { t } = useTranslation();

  const isEditable = isSchemaFieldEditable(schema);

  return (
    <div className="schema-builder-field-actions">
      {!isEditable ? (
        <Button
          type="text"
          aria-label={t("schema:action.previewField")}
          title={t("schema:action.previewField")}
          icon={<ReadOutlined />}
          onClick={onPreviewClick}
        />
      ) : (
        <>
          <Button
            type="text"
            aria-label={t("schema:action.editField")}
            title={t("schema:action.editField")}
            icon={<EditOutlined />}
            onClick={onEditClick}
          />
          <Button
            type="text"
            aria-label={t("schema:action.copyField")}
            title={t("schema:action.copyField")}
            icon={<CopyOutlined />}
            onClick={onCopyClick}
          />
          <Button
            danger
            type="text"
            aria-label={t("schema:action.deleteField")}
            title={t("schema:action.deleteField")}
            icon={<DeleteOutlined />}
            onClick={onDeleteClick}
          />
        </>
      )}
    </div>
  );
};
